import { observer } from 'mobx-react';
import { computed } from 'mobx';
import * as React from 'react';

import { InviteResponse } from 'src/api/model/inviteResponse';
import { EmailFormState, EmailActionResult } from '../../shared/email-form-state';
import { lazyInject } from '../../ioc';
import { InviteErrorCode, LoginApiService } from 'src/api';

import { ClientDataStore } from 'src/core/stores/client-data.store';
import { SignUpEmail } from './desktop/sign-up-email';

@observer
export class SignUpEmailContainer extends React.Component {
    @lazyInject(ClientDataStore) private clientData!: ClientDataStore;
    @lazyInject(LoginApiService) private loginApi!: LoginApiService;

    @computed private get phone() {
        return this.clientData.portalData && this.clientData.portalData.brandData.phone;
    }

    data = new EmailFormState((email) => this.invite(email));

    async invite(email: string): Promise<EmailActionResult> {
        const { data } = await this.loginApi.invite({ email });
        return {
            message: this.getMessage(data, email),
            emailSent: data.success,
        };
    }

    private getMessage(response: InviteResponse, email: string): string {
        if (response.success) {
            return `A link to join our customer portal has been sent to ${email}`;
        }
        if (response.errorCode === InviteErrorCode.NUMBER_2) {
            return `Please contact the office at ${this.phone} to register.`;
        }
        return 'Failed to send email';
    }

    render() {
        return <SignUpEmail container={this} />;
    }
}
